import React from 'react';
import { loadingStyles } from './Loading.styles';

export const Loading: React.FC = () => {
  return <div css={loadingStyles.loader} />;
};
